import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=35c3cff0&scoped=true"
import script from "./Datenschutz.vue?vue&type=script&lang=js"
export * from "./Datenschutz.vue?vue&type=script&lang=js"
import style0 from "./Datenschutz.vue?vue&type=style&index=0&id=35c3cff0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c3cff0",
  null
  
)

export default component.exports